export const mapAsplProduct = (p) => {
  if (!p || typeof p !== "object") return null;

  const safeArr = Array.isArray(p.photos) ? p.photos.filter(Boolean) : [];
  const firstPhoto = p.photo || safeArr[0] || null;

  const stockInfo = Array.isArray(p.stockInfoList?.stockInfo)
    ? p.stockInfoList.stockInfo[0] || {}
    : {};

  return {
    id: p.id || "",
    name: p.name || p.productName || "No Name",
    brand: p.producer || p.brand || "",
    producer: p.producer || "",
    reference: p.reference || "",
    oem: p.reference2 || "",
    tecnum: p.tecnum || "",
    tecidd: p.tecidd || "",

    category: p.groupName || "",
    category_id: p.group2 || "",
    groupName: p.groupName || "",

    deliveryDate: p.expectedDeliveryDate || "",
    tax: p.tax || "",
    currency: p.currency || "USD",

    priceUSD: p.price_usd ?? stockInfo.priceInclTax ?? null,
    priceEx: stockInfo.priceExclTax ?? null,
    priceNGN: p.price_ngn ?? null,
    exchangeRate: p.exchange_rate ?? null,

    stock: p.stock ?? stockInfo.quantityReal ?? 0,

    photos: safeArr,
    firstPhoto,

    barcodes: Array.isArray(p.barCodeList?.barCode) ? p.barCodeList.barCode : [],
  };
};
